import { render, staticRenderFns } from "./component-a07213a1.vue?vue&type=template&id=ec95fa54&"
import script from "./component-a07213a1.vue?vue&type=script&lang=js&"
export * from "./component-a07213a1.vue?vue&type=script&lang=js&"
import style0 from "./component-a07213a1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports